"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = audioInputDevice;
var _types = require("../../actions/meeting/types");
function audioInputDevice() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_SET_AUDIO_DEVICE, "_SUCCESS")) {
    return (action === null || action === void 0 ? void 0 : action.payload) || state;
  }
  if (action.type === _types.BROADCAST_SET_AUDIO_DEVICE) {
    return action.payload || state;
  }
  return state;
}